<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 顶部门店选择 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="storeId" placeholder="请选择门店" @change="loadAll">
                    <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-tabs v-model="activeTab">
          <!-- 打印机 -->
          <a-tab-pane tab="打印机" key="printer">
            <div class="table-operator">
              <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handlePrinterAdd">新增打印机</a-button>
              <a-button icon="reload" @click="loadPrinters">刷新</a-button>
            </div>
            <a-table size="middle" bordered rowKey="id" :columns="printerColumns" :dataSource="printers"
              :scroll="scroll" :loading="loading" :pagination="false">
              <span slot="printerAction" slot-scope="text, record">
                <a @click="handlePrinterTest(record)">测试</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handlePrinterEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handlePrinterDelete(record)">删除</a>
              </span>
              <template slot="printerStatus" slot-scope="text, record">
                <a-tag :color="statusColor[record.displayStatus] || 'default'">{{ statusText[record.displayStatus] || record.displayStatus || '未知' }}</a-tag>
              </template>
              <template slot="connectType" slot-scope="text">{{ connectTypeText[text] || text }}</template>
              <template slot="targetInfo" slot-scope="text, record">
                <span v-if="record.targetType === 'local'">{{ record.localPrinterName || '-' }}</span>
                <span v-else-if="record.ip">{{ record.ip }}:{{ record.port || 9100 }}</span>
                <span v-else>{{ record.cloudVendor || '-' }}</span>
              </template>
            </a-table>
          </a-tab-pane>
          <!-- 档口 -->
          <a-tab-pane tab="厨房档口" key="station">
            <div class="table-operator">
              <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleStationAdd">新增档口</a-button>
              <a-button icon="coffee" @click="handleAssignStation">菜品分配档口</a-button>
            </div>
            <a-table size="middle" bordered rowKey="id" :columns="stationColumns" :dataSource="stations"
              :scroll="scroll" :loading="loading" :pagination="false">
              <span slot="stationAction" slot-scope="text, record">
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleStationEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleStationDelete(record)">删除</a>
              </span>
              <template slot="stationPrinter" slot-scope="text">{{ printerName(text) }}</template>
              <template slot="granularity" slot-scope="text">{{ granularityText[text] || text }}</template>
              <template slot="mergeSame" slot-scope="text">{{ text === '1' ? '合并' : '不合并' }}</template>
            </a-table>
          </a-tab-pane>
          <!-- 网关 -->
          <a-tab-pane tab="打印网关" key="gateway">
            <a-alert style="margin-bottom:12px" type="info" show-icon
              message="网关是运行在门店收银机上的打印服务（dining-print-gateway）：新建记录后生成配对码，在网关控制台输入 ERP 地址+配对码完成绑定，绑定后长轮询拉单打印。" />
            <div class="table-operator">
              <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleGatewayAdd">新增网关</a-button>
              <a-button icon="reload" @click="loadGateways">刷新</a-button>
            </div>
            <a-table size="middle" bordered rowKey="id" :columns="gatewayColumns" :dataSource="gateways"
              :scroll="scroll" :loading="loading" :pagination="false">
              <span slot="gatewayAction" slot-scope="text, record">
                <a @click="handlePairCode(record)">生成配对码</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleGatewayDelete(record)">删除</a>
              </span>
              <template slot="gwStatus" slot-scope="text">
                <a-tag :color="text === 'online' ? 'green' : 'default'">{{ text === 'online' ? '在线' : '离线' }}</a-tag>
              </template>
            </a-table>
          </a-tab-pane>
          <!-- 模板 -->
          <a-tab-pane tab="小票模板" key="template">
            <a-alert style="margin-bottom:12px" type="info" show-icon
              message="行式模板：控制各单据类型的标题与打印内容开关，保存即时生效（租户配置覆盖系统默认）。" />
            <a-table size="middle" bordered rowKey="billType" :columns="templateColumns" :dataSource="templates"
              :loading="loading" :pagination="false">
              <span slot="templateAction" slot-scope="text, record">
                <a @click="handleTemplateEdit(record)">编辑</a>
              </span>
            </a-table>
          </a-tab-pane>
          <!-- 日志 -->
          <a-tab-pane tab="打印日志" key="log">
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="5" :sm="24">
                    <a-form-item label="单据" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="logQuery.billType" placeholder="全部类型" allow-clear>
                        <a-select-option v-for="(v, k) in billTypeText" :key="k" :value="k">{{ v }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="logQuery.status" placeholder="全部状态" allow-clear>
                        <a-select-option value="pending">待下发</a-select-option>
                        <a-select-option value="delivered">已下发</a-select-option>
                        <a-select-option value="success">成功</a-select-option>
                        <a-select-option value="failed">失败</a-select-option>
                        <a-select-option value="manual">转人工</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="14" :sm="24">
                    <a-button type="primary" @click="loadLogs(1)">查询</a-button>
                    <a-button style="margin-left:8px" icon="reload" @click="resetLogQuery">重置</a-button>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <a-table size="middle" bordered rowKey="id" :columns="logColumns" :dataSource="logs"
              :scroll="scroll" :loading="loading"
              :pagination="{ current: logQuery.pageNo, pageSize: logQuery.pageSize, total: logTotal, showSizeChanger: true, pageSizeOptions: ['10','20','50'], onChange: loadLogs }">
              <span slot="logAction" slot-scope="text, record">
                <a @click="handleReprint(record)">补打</a>
              </span>
              <template slot="logBillType" slot-scope="text">{{ billTypeText[text] || text }}</template>
              <template slot="logStatus" slot-scope="text">
                <a-tag :color="logStatusColor[text] || 'default'">{{ logStatusText[text] || text }}</a-tag>
              </template>
              <template slot="logTime" slot-scope="text">{{ text || '-' }}</template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
        <!-- 弹窗 -->
        <printer-modal ref="printerModal" :store-id="storeId" :gateways="gateways" :stations="stations" @ok="loadPrinters"></printer-modal>
        <station-modal ref="stationModal" :store-id="storeId" :printers="printers" @ok="loadStations"></station-modal>
        <goods-station-modal ref="goodsStationModal" :stations="stations"></goods-station-modal>
        <template-modal ref="templateModal" @ok="loadTemplates"></template-modal>
        <!-- 新增网关（输入名称） -->
        <a-modal title="新增打印网关" :visible="gatewayAddVisible" :confirmLoading="confirmLoading" @ok="doGatewayAdd" @cancel="gatewayAddVisible = false">
          <a-form-item label="网关名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="gatewayName" placeholder="如：前台收银机" @pressEnter="doGatewayAdd" />
          </a-form-item>
          <p style="color:#999;margin:0 0 0 16.6%">创建后点击「生成配对码」，在网关控制台输入 ERP 地址与配对码完成绑定。</p>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { storeOptions, printerList, printerDelete, printerTest, stationList, stationDelete,
  gatewayList, gatewayCreate, gatewayDelete, gatewayPairCode, printLogList, printLogReprint, printTemplates } from '@/api/plugin/dining'
import PrinterModal from './PrinterModal'
import StationModal from './StationModal'
import GoodsStationModal from './GoodsStationModal'
import TemplateModal from './TemplateModal'

export default {
  name: 'DiningPrintManage',
  mixins: [JeecgListMixin],
  components: { PrinterModal, StationModal, GoodsStationModal, TemplateModal },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      activeTab: 'printer',
      storeOptionList: [],
      storeId: null,
      printers: [],
      stations: [],
      gateways: [],
      templates: [],
      logs: [],
      logTotal: 0,
      gatewayAddVisible: false,
      gatewayName: '',
      confirmLoading: false,
      logQuery: { billType: undefined, status: undefined, pageNo: 1, pageSize: 20 },
      urlPath: '/plugin/dining/print-manage',
      // JeecgListMixin 的 loadData/initDictConfig 会访问 this.url，缺对象会抛 TypeError 中断
      // created 钩子，导致 initActiveBtnStr（按钮权限初始化）不执行、增删改按钮全部不显示
      url: {},
      roleText: { merchant: '商家联', customer: '顾客联', expo: '传菜联', area: '区域联', kitchen: '厨房联' },
      statusText: { online: '在线', error: '异常', idle: '空闲', offline: '离线' },
      statusColor: { online: 'green', error: 'red', idle: 'blue', offline: 'default' },
      connectTypeText: { gateway: '门店网关', cloud: '云盒', direct: '直连' },
      granularityText: { per_order: '整单', per_item: '单菜', per_category: '分类' },
      billTypeText: { JCD: '加菜单', TCD: '退菜单', ZFD: '作废单', HCD: '换桌单', KB: '厨房联', CC: '传菜联', QY: '区域联', JZD: '结算单', YJD: '预结单' },
      logStatusText: { pending: '待下发', delivered: '已下发', success: '成功', failed: '失败', manual: '转人工' },
      logStatusColor: { pending: 'orange', delivered: 'blue', success: 'green', failed: 'red', manual: 'purple' },
      printerColumns: [
        { title: '操作', dataIndex: 'action', width: 140, align: 'center', scopedSlots: { customRender: 'printerAction' } },
        { title: '名称', dataIndex: 'name', width: 130, align: 'left' },
        { title: '通道', dataIndex: 'connect_type', width: 90, align: 'center', scopedSlots: { customRender: 'connectType' } },
        { title: '目标', dataIndex: 'targetInfo', width: 170, align: 'left', scopedSlots: { customRender: 'targetInfo' } },
        { title: '状态', dataIndex: 'displayStatus', width: 80, align: 'center', scopedSlots: { customRender: 'printerStatus' } },
        { title: '纸张', dataIndex: 'paper_type', width: 70, align: 'center', customRender: t => (t || '80') + 'mm' },
        { title: '份数', dataIndex: 'copies', width: 60, align: 'center' },
        { title: '业务', dataIndex: 'business_types', width: 85, align: 'left', customRender: t => t || '-' },
        { title: '联次角色', dataIndex: 'roles', width: 160, align: 'left',
          customRender: t => (t || '').split(',').filter(Boolean).map(r => this.roleText[r] || r).join('/') || '-' },
        { title: '事件单', dataIndex: 'event_types', width: 85, align: 'left', customRender: t => t || '-' }
      ],
      stationColumns: [
        { title: '操作', dataIndex: 'action', width: 110, align: 'center', scopedSlots: { customRender: 'stationAction' } },
        { title: '档口名称', dataIndex: 'name', width: 130, align: 'left' },
        { title: '打印机', dataIndex: 'printer_id', width: 140, align: 'left', scopedSlots: { customRender: 'stationPrinter' } },
        { title: '拆单粒度', dataIndex: 'granularity', width: 100, align: 'center', scopedSlots: { customRender: 'granularity' } },
        { title: '同款合并', dataIndex: 'merge_same', width: 90, align: 'center', scopedSlots: { customRender: 'mergeSame' } },
        { title: '排序', dataIndex: 'sort', width: 70, align: 'center' }
      ],
      gatewayColumns: [
        { title: '操作', dataIndex: 'action', width: 140, align: 'center', scopedSlots: { customRender: 'gatewayAction' } },
        { title: '名称', dataIndex: 'name', width: 130, align: 'left' },
        { title: 'SN', dataIndex: 'sn', width: 180, align: 'left', customRender: t => t || '（待配对）' },
        { title: '状态', dataIndex: 'status', width: 80, align: 'center', scopedSlots: { customRender: 'gwStatus' } },
        { title: '最近心跳', dataIndex: 'last_seen_time', width: 160, align: 'center', customRender: t => t || '-' },
        { title: '网关版本', dataIndex: 'version', width: 100, align: 'center', customRender: t => t || '-' }
      ],
      templateColumns: [
        { title: '操作', dataIndex: 'action', width: 80, align: 'center', scopedSlots: { customRender: 'templateAction' } },
        { title: '单据类型', dataIndex: 'billType', width: 100, align: 'center' },
        { title: '名称', dataIndex: 'title', width: 130, align: 'left' },
        { title: '当前标题', width: 160, align: 'left', customRender: (t, r) => (r.config && r.config.title) || r.title }
      ],
      logColumns: [
        { title: '操作', dataIndex: 'action', width: 70, align: 'center', scopedSlots: { customRender: 'logAction' } },
        { title: '单据', dataIndex: 'bill_type', width: 90, align: 'center', scopedSlots: { customRender: 'logBillType' } },
        { title: '状态', dataIndex: 'status', width: 85, align: 'center', scopedSlots: { customRender: 'logStatus' } },
        { title: '打印机', dataIndex: 'printer_name', width: 120, align: 'left', customRender: t => t || '-' },
        { title: '档口', dataIndex: 'station_name', width: 100, align: 'left', customRender: t => t || '-' },
        { title: '订单', dataIndex: 'order_no', width: 140, align: 'left', customRender: t => t || '-' },
        { title: '重试', dataIndex: 'retry_count', width: 60, align: 'center' },
        { title: '错误信息', dataIndex: 'error_message', width: 180, align: 'left', customRender: t => t || '-' },
        { title: '时间', dataIndex: 'create_time', width: 150, align: 'center', scopedSlots: { customRender: 'logTime' } }
      ]
    }
  },
  created() {
    storeOptions().then(res => {
      if (res.code === 200) {
        this.storeOptionList = res.data || []
        if (this.storeOptionList.length) {
          this.storeId = this.storeOptionList[0].id
          this.loadAll()
        }
      } else {
        this.$message.warning(res.message)
      }
    })
  },
  methods: {
    // 覆盖 JeecgListMixin.loadData：本页在 created 里经 loadAll 按门店加载，
    // 不走 mixin 的 url.list 请求逻辑；空实现保证 mixin created 不被中断，
    // 使 initActiveBtnStr 正常执行（按钮权限）
    loadData() {},
    loadAll() {
      this.loadPrinters()
      this.loadStations()
      this.loadGateways()
      this.loadTemplates()
      this.loadLogs(1)
    },
    loadPrinters() {
      if (!this.storeId) return
      this.loading = true
      printerList({ storeId: this.storeId }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.printers = res.data || []
        } else {
          this.$message.warning(res.message)
        }
      }).catch(() => { this.loading = false })
    },
    loadStations() {
      if (!this.storeId) return
      stationList({ storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.stations = res.data || []
        }
      })
    },
    loadGateways() {
      if (!this.storeId) return
      this.loading = true
      gatewayList({ storeId: this.storeId }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.gateways = res.data || []
        }
      }).catch(() => { this.loading = false })
    },
    loadTemplates() {
      this.loading = true
      printTemplates().then(res => {
        this.loading = false
        if (res.code === 200) {
          this.templates = res.data || []
        }
      }).catch(() => { this.loading = false })
    },
    loadLogs(page) {
      if (!this.storeId) return
      if (typeof page === 'number') this.logQuery.pageNo = page
      this.loading = true
      printLogList(Object.assign({ storeId: this.storeId }, this.logQuery)).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.logs = res.data.rows || []
          this.logTotal = res.data.total || 0
        }
      }).catch(() => { this.loading = false })
    },
    resetLogQuery() {
      this.logQuery = { billType: undefined, status: undefined, pageNo: 1, pageSize: this.logQuery.pageSize }
      this.loadLogs(1)
    },
    printerName(id) {
      const p = this.printers.find(x => x.id === id)
      return p ? p.name : (id ? '（已删除）' : '-')
    },
    // ---- 打印机 ----
    handlePrinterAdd() { this.$refs.printerModal.add() },
    handlePrinterEdit(record) { this.$refs.printerModal.edit(record) },
    handlePrinterTest(record) {
      printerTest(record.id).then(res => {
        if (res.code === 200) {
          this.$message.success('测试打印已下发，请查看打印机出纸')
          this.loadPrinters()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handlePrinterDelete(record) {
      this.$confirm({ title: '确认删除打印机「' + record.name + '」？', onOk: () => {
        printerDelete(record.id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.loadPrinters()
          } else {
            this.$message.warning(res.message)
          }
        })
      }})
    },
    // ---- 档口 ----
    handleStationAdd() { this.$refs.stationModal.add() },
    handleStationEdit(record) { this.$refs.stationModal.edit(record) },
    handleStationDelete(record) {
      this.$confirm({ title: '确认删除档口「' + record.name + '」？', content: '已分配到该档口的菜品将不再打印厨房联。', onOk: () => {
        stationDelete(record.id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.loadStations()
          } else {
            this.$message.warning(res.message)
          }
        })
      }})
    },
    handleAssignStation() { this.$refs.goodsStationModal.show() },
    // ---- 网关 ----
    handleGatewayAdd() {
      this.gatewayName = ''
      this.gatewayAddVisible = true
    },
    doGatewayAdd() {
      if (!this.gatewayName.trim()) {
        this.$message.warning('请输入网关名称')
        return
      }
      this.confirmLoading = true
      gatewayCreate({ storeId: this.storeId, name: this.gatewayName.trim() }).then(res => {
        this.confirmLoading = false
        if (res.code === 200) {
          this.$message.success('新建成功，请生成配对码完成绑定')
          this.gatewayAddVisible = false
          this.loadGateways()
        } else {
          this.$message.warning(res.message)
        }
      }).catch(() => { this.confirmLoading = false })
    },
    handlePairCode(record) {
      gatewayPairCode(record.id).then(res => {
        if (res.code === 200) {
          this.$info({ title: '网关配对码（一次性）', content: '配对码：' + res.data.pairCode + '，请在网关控制台「绑定 ERP」处输入服务器地址与该配对码完成绑定，配对成功后立即失效。' })
          this.loadGateways()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleGatewayDelete(record) {
      this.$confirm({ title: '确认删除网关「' + record.name + '」？', content: '该网关下发的打印机将无法出单，请先确认无打印机引用。', onOk: () => {
        gatewayDelete(record.id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.loadGateways()
          } else {
            this.$message.warning(res.message)
          }
        })
      }})
    },
    // ---- 模板 ----
    handleTemplateEdit(record) { this.$refs.templateModal.edit(record) },
    // ---- 日志 ----
    handleReprint(record) {
      printLogReprint(record.id).then(res => {
        if (res.code === 200) {
          this.$message.success('补打已下发')
          this.loadLogs()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
